import * as React from 'react';
import { FC, memo } from 'react';
import { IPaymentInitiateTicketResult } from '../../../store/paymentV1/types';
import Constants from '../../../store/constants';
import { ListItem } from './eventCheckoutHeaderV1';
import EventInfoItemV1 from '../eventInfoItemV1';
import { useUtils } from '../../../services/useUtils';

type RenderTicketsInfoPropsType = {
  tickets: Array<IPaymentInitiateTicketResult>;
};

export const RenderTicketsInfoV1: FC<RenderTicketsInfoPropsType> = memo(({ tickets }) => {
  const { getTicketsPostfixByCount } = useUtils();
  if (!tickets.length) {
    return null;
  }
  return (
    <ListItem>
      {tickets.map((ticket, index) => {
        const title = `${ticket.quantity} ${getTicketsPostfixByCount(ticket.quantity)} ${Constants.BulletDelimiter} 
          ${ticket.title}`;
        return <EventInfoItemV1 key={index} icon={index === 0 ? 'person' : null} themed title={title} />;
      })}
    </ListItem>
  );
});
